'use stric'

const carsTypes = [
  {
    id: -1,
    title: 'Нет данных',
    name: 'noData'
  },
  {
    id: 1,
    title: 'В движении',
    name: 'inMove'
  },
  {
    id: 0,
    title: 'Стоянка',
    name: 'parking'
  }
]

// const getCarsTypeTitle = (id) => {
//   return carsTypes.filter((item) => item.id === id)[0].title
// }
const getCarsTypeTitle = (id) => {
  return carsTypes.filter((item) => item.id === id)[0].title
}

const getCarsTypeName = (id) => {
  return carsTypes.filter((item) => item.id === id)[0].name
}

export {
  carsTypes,
  getCarsTypeTitle,
  getCarsTypeName
}